import useCreate from '../../useCreate';
import toast from 'react-hot-toast';

const useCreateFaq = ({ reset }) => {
  const { setDataToServer } = useCreate({
    url: 'faqs/create',
    refreshUrl: 'faqs/list',
    onSuccess: () => {
      reset?.();
      toast.success("FAQ Added Successfully", {
        position: "top-right",
        duration: 3000
      });
    },
    onError: (error) => {
      const apiMessage = error?.response?.data?.message;
      toast.error(apiMessage || "Error Creating FAQ", {
        position: "top-right",
        duration: 3000
      });
    }
  });
  
  const handleSubmit = (data) => {
    setDataToServer.mutate(data);
  };

  return { handleSubmit };
};

export default useCreateFaq;
